export class Utils {

  public static persianNumbers = {
    0: 'صفرم',
    1: 'اول',
    2: 'دوم',
    3: 'سوم',
    4: 'چهارم',
    5: 'پنجم',
    6: 'ششم',
    7: 'هفتم',
    8: 'هشتم',
    9: 'نهم',
    10: 'دهم',
  };

  public static sleep(milliseconds) {
    let start = new Date().getTime();
    for (let i = 0; i < 1e7; i++) {
      // console.log('updating...');
      if ((new Date().getTime() - start) > milliseconds){
        break;
      }
    }
  }

  public static hexToRgbA(hex: string, alpha: number= 1){
    let c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
      c= hex.substring(1).split('');
      if(c.length== 3){
        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c= '0x'+c.join('');
      return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+`,${alpha})`;
    }
    return hex
  }

  public static getPersianNumber(value){
    return Utils.persianNumbers[value]
  }

  public static extractRawTextFromRichText(richText: string){
    const temp = document.createElement('div');
    temp.innerHTML = richText || '';
    return temp.textContent?.trim() || '';
  }
}
